import { render, staticRenderFns } from "./smartscenicspotdistributionSystem.vue?vue&type=template&id=1ce28072&scoped=true"
import script from "./smartscenicspotdistributionSystem.vue?vue&type=script&lang=js"
export * from "./smartscenicspotdistributionSystem.vue?vue&type=script&lang=js"
import style0 from "./smartscenicspotdistributionSystem.vue?vue&type=style&index=0&id=1ce28072&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce28072",
  null
  
)

export default component.exports